import { CylinderGeometry } from 'three'

// Rotate the unit roof BEFORE rectangular scaling. Rotating a stretched
// four-sided cylinder afterwards creates a diamond that escapes long wings.
export function parisMansardGeometry(){
  return new CylinderGeometry(.68,1,1,4).rotateY(Math.PI/4).scale(1/Math.SQRT2,1,1/Math.SQRT2)
}
